module.exports = __webpack_public_path__ + "aprile-25.jpg?ba653314e796d71a016a48e73e730e0e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aprile-25.jpg
// module id = 148
// module chunks = 0